import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type WaitlistRoutes = {
    waitlist: Route
    preview: Route
}

export const waitlistRoutes: WaitlistRoutes = {
    waitlist: {
        path: 'dashboard/waitlist',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard(
                [PERMISSIONS.waitlist.read, PERMISSIONS.waitlist.write],
                {
                    redirectTo: ['/dashboard/home'],
                },
            ),
        ],
        loadComponent: () =>
            import('./page-waitlist/page-waitlist.component').then(
                (m) => m.PageWaitlistComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    preview: {
        path: 'waitlist/preview/:shopId',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard(
                [PERMISSIONS.waitlist.read, PERMISSIONS.waitlist.write],
                {
                    redirectTo: ['/dashboard/home'],
                },
            ),
        ],
        loadComponent: () =>
            import('./page-waitlist-preview/page-waitlist-preview.component').then(
                (m) => m.PageWaitlistPreviewComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
}
